import { LiveVideoSource } from '../realtime/contracts';
import type {
  Attachment,
  CollaborationState,
  LiveVideoAppleEed,
  Incident,
  LiveVideo,
} from '../realtime/contracts';

export function agencyIdEquals(a: string, b: string): boolean {
  return a.toLowerCase() === b.toLowerCase();
}

export function getAgencyView(incident: Incident, agencyId: string) {
  return incident.agencyViews.find((view) => agencyIdEquals(view.agencyId, agencyId)) ?? null;
}

export function getCollaborationState(incident: Incident, agencyId: string): CollaborationState | null {
  return (
    incident.involvedAgencies.find((agency) => agencyIdEquals(agency.agencyId, agencyId))?.state ?? null
  );
}

export function isAppleEedLiveVideo(liveVideo: LiveVideo | null): liveVideo is LiveVideoAppleEed {
  return liveVideo?.source === LiveVideoSource.AppleEed;
}

export function isVideoAttachment(attachment: Attachment): boolean {
  return attachment.mimeType.toLowerCase().startsWith('video/');
}

export function medicDataAge(yearOfBirth: number | null, createdAtUtc: string): number | null {
  return yearOfBirth != null ? new Date(createdAtUtc).getFullYear() - yearOfBirth : null;
}

export function orderShowFirst<T>(source: readonly T[], predicate: (item: T) => boolean): T[] {
  return [...source].sort((a, b) => Number(!predicate(a)) - Number(!predicate(b)));
}
